.fg{width:max-content;}